import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { api } from "../lib/auth";

/**
 * Read-only dashboard nudge for members whose intake status is
 * "ready_for_matching". Adds no new backend model.
 */
export default function MatchReadyNudge() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/intake/me");
        const status = data?.intake?.status;
        if (alive) setReady(status === "ready_for_matching");
      } catch (_e) {
        if (alive) setReady(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  if (!ready) return null;
  return (
    <div
      data-testid="match-ready-nudge"
      className="rounded-2xl p-5 border-2 border-[#2D9B4E] bg-gradient-to-r from-[#2D9B4E]/10 to-white flex items-center gap-4"
    >
      <div className="w-11 h-11 rounded-full bg-[#23803F] text-white flex items-center justify-center shrink-0">
        <Sparkles className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-bold text-[#0B132B]">Your Buddy matches are ready</div>
        <div className="text-sm text-[#4B5563]">
          A Specialist reviewed your intake — you're cleared for matching. Explore your recommended Buddies.
        </div>
      </div>
      <Link
        to="/portal/matches"
        data-testid="match-ready-cta"
        className="btc-btn-primary text-sm shrink-0"
      >
        See matches <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
}
